import { Component } from '@angular/core';
import { NavController,ToastController,ModalController, NavParams, ViewController,AlertController } from 'ionic-angular';
import { Params } from '../params';
import * as firebase from 'firebase/app';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';

@Component({
  selector: 'page-plans',
  templateUrl: 'plans.html'
})
export class PlansPage {
  foods : any;
  foodsObj;
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private alertCtrl : AlertController) {
    // this.plans = this.db.list('plans');
    this.foods = [];
    this.foodsObj = {};
    firebase.database().ref('/foods').once('value').then((snapshot)=>{
      let ref_plans = snapshot.val();
      this.foodsObj = snapshot.val();
      for(let i=0;i<Object.keys(ref_plans).length;i++){
        let temp_plan = ref_plans[Object.keys(ref_plans)[i]];
        temp_plan.key = Object.keys(ref_plans)[i];
        if(temp_plan["active"]) this.foods.push(temp_plan);
      }
      if(this.foods.length==0){
        let alert = this.alertCtrl.create({
          title: 'No hay comidas',
          subTitle: 'Antes de configurar planes, debe activar/crear comidas',
          buttons: ['Aceptar']
        });
        alert.present();
      }
    });
  }

  newPlan(plan) {
    let params = {};
    params["foods"] = this.foods;
    params["plan"] = plan;
    let modal = this.modalCtrl.create(PlanPage, params);
    modal.present();
  }

  updateActive(plan){
    // this.plans.update(plan.$key, { active: plan.active });
  }

  deletePlan(key){
    // this.plans.remove(key);
  }
}

@Component({selector: 'page-plan', templateUrl: 'plan.html'})
export class PlanPage {
  title:string;
  edit : boolean = false;
  foods:any;
  addForm: FormGroup;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    private builder: FormBuilder,
    public toastCtrl: ToastController
  ) {

    this.foods = this.params.get("foods");
    this.addForm = builder.group({
      'code': ['', Validators.required],
      'name': ['', Validators.required],
      'foods': ['', Validators.required]
    })
    this.title = "Nuevo Plan";
    //this.customer = this.params.get('customer');
    if(this.params.get("plan")){
      let plan = this.params.get("plan");
      this.edit = true;
      this.title = "Editar Plan";
      this.addForm = builder.group({
        'code': [plan["$key"], Validators.required],
        'name': [plan["name"], Validators.required],
        'foods': [plan["foods"], Validators.required]
      })
    }
  }

  save() {
    let data = this.addForm.value;
    let code = Params.key_parse(data.code);
    let food = {
      name : data.name,
      foods : data.foods,
      active: true,
      key : code
    };
    /* this.plan = this.db.object('plans/'+code);
    this.plan.set(food).then(_ => {
      let word = "creado";
      if(this.edit) word = "editado";
      let toast = this.toastCtrl.create({
        message: 'Plan '+data.name+' '+word+' exitosamente',
        duration: 3000
      });
      toast.present();
    }); */

    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/plans/plans.ts